import { cn } from "@/lib/utils.ts";
import { ChevronLeft, X } from "lucide-react";
import { SettingsSheetHeaderProps } from "@/components/SettingsSidepanel/settings.types.ts";
import { Button } from "../ui/button";

const SettingsSheetHeader: React.FC<SettingsSheetHeaderProps> = ({
  onRequestClose,
  title,
  onBack,
}) => {
  return (
    <div
      id="account-tab-header"
      className={cn(
        "text-foreground bg-primary sticky top-0 z-50 flex flex-none items-center justify-between space-x-5 py-5 font-medium h-18",
      )}
    >
      <div className="flex w-7/10 items-center gap-5">
        {onBack && (
          <Button size={"sm"} variant={"paint"} onClick={onBack}>
            <ChevronLeft />
          </Button>
        )}
        <label className={cn("text-xl")}>{title}</label>
      </div>

      <div className="flex items-center gap-2">
        <X
          onClick={onRequestClose}
          className="h-6 w-6 cursor-pointer rounded-sm p-1"
        />
      </div>
    </div>
  );
};

export default SettingsSheetHeader;
